'use strict';

import ngResource from 'angular-resource';

class PredictedPowerService {
    constructor($resource) {
        'ngInject';
        this.api = $resource(
            '/api/predicted_power/:id',
            { id: '@id' },
            {
                show: { method: 'GET', isArray: false }
            }
        );
    }
}

export default angular.module('leptonApp.PredictedPowerService', ['ngResource'])
  .service('PredictedPowerService', ['$resource', PredictedPowerService])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/predicted_power/predicted_power.service.js